import MuiChip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import styles from './chip.module.scss';

const Chip = ({ label, size = 'medium', color = 'default', clickable, onClick }) => {
    return (
        <MuiChip
            className={styles.root}
            label={label}
            size={size}
            color={color}
            clickable={clickable}
            onClick={onClick}
            variant="filled"
        />
    );
};

Chip.propTypes = {
    label: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    color: PropTypes.oneOf(['primary', 'secondary', 'default']),
    clickable: PropTypes.bool,
    onClick: PropTypes.func
};

export default Chip;
